document.addEventListener('DOMContentLoaded', function() {
    function updateCountdown() {
        const now = new Date();
        const deadline = new Date();
        deadline.setHours(13, 0, 0, 0); // 1 PM deadline

        // If the deadline has passed for today, hide the countdown
        if (now.getHours() >= 13) {
            document.getElementById('countdown-ticker').style.display = 'none';
            return;
        }

        const timeRemaining = deadline - now;
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        document.getElementById('countdown-ticker').innerHTML = `Order before 1pm for same day dispatch: <span>${hours} hours ${minutes} minutes ${seconds} seconds</span>`;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000); // Update every second
});
